import { Box, Typography } from "@mui/material"
import React from "react"

export function NoMatch(): React.JSX.Element {
  return (
    <Box
      height="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignContent="center"
      alignItems="center">
      <Typography variant="h3">Cette page n'existe pas</Typography>
    </Box>
  )
}
